/* eslint-disable react-hooks/exhaustive-deps */
import debounce from "debounce-promise"
import React from "react"
import {useTranslation} from "react-i18next"
import {rateSheetsService} from "services"
import {KlassDropdownAsync, KlassDropdownAsyncProps} from "../Select"

type Props = Partial<KlassDropdownAsyncProps> & {}

const RateSheetSelect: React.FC<Props> = ({...props}) => {
    const {t} = useTranslation(["common"])

    const search = React.useCallback(
        debounce(async (search: string = "") => {
            const {data} = await rateSheetsService.getAll({
                filter: {
                    search
                },
                range: {
                    page: 1,
                    pageSize: 20
                },
                linkedEntities: ["rates"]
            })
            return data
        }, 500),
        []
    )

    return (
        <KlassDropdownAsync
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={search}
            defaultOptions
            valueKey="rateSheetId"
            labelKey="name"
        />
    )
}

export default RateSheetSelect
